export const REPORTS_AREAS = {
  PAYMENT_PLANS: {
    value: 'with_payment_plans',
    description: 'Zahlpläne'
  },
  PROFIT_LOSS: {
    value: 'with_profit_loss',
    isDisabledForDepotStatus: true,
    description: 'vollständig verkaufte Vermögenswerte'
  },
  INCLUDE_HISTORICAL_PORTFOLIOS: {
    value: 'include_historical_portfolios',
    description: 'historische Depots'
  },
  WITH_TRANSACTION_SALDO: {
    value: 'with_transaction_saldo',
    description: 'Transaktionssaldo'
  },
  OTHER_ASSETS: {
    value: 'with_other_assets',
    description: 'Sonstige Vermögenswerte (exkl. Verrechnungskonto)'
  },
  TRANSACTIONS_MONITOR: {
    value: 'with_transactions_monitor',
    description: 'Transaktionsmonitor'
  },
  LIABILITIES: {
    value: 'with_liabilities',
    description: 'Verbindlichkeiten'
  },
};

export const REPORTS_AREAS_LIST_V2 = [
  REPORTS_AREAS.OTHER_ASSETS,
  REPORTS_AREAS.INCLUDE_HISTORICAL_PORTFOLIOS,
  REPORTS_AREAS.WITH_TRANSACTION_SALDO,
  REPORTS_AREAS.PROFIT_LOSS,
  REPORTS_AREAS.TRANSACTIONS_MONITOR,
  REPORTS_AREAS.PAYMENT_PLANS,
];

// For customers dashboard settings we moved Historical Depot to new place in BCA-8141.
// That is why we have separate constant without this option
export const CUSTOMER_RELATED_REPORTS_AREAS_LIST_V2 = REPORTS_AREAS_LIST_V2.filter(
  (option) => option.value !== REPORTS_AREAS.INCLUDE_HISTORICAL_PORTFOLIOS.value);


export const REPORTS_AREAS_LIST = [
  REPORTS_AREAS.OTHER_ASSETS,
  REPORTS_AREAS.LIABILITIES,
  REPORTS_AREAS.INCLUDE_HISTORICAL_PORTFOLIOS,
  REPORTS_AREAS.WITH_TRANSACTION_SALDO,
  REPORTS_AREAS.PROFIT_LOSS,
  REPORTS_AREAS.TRANSACTIONS_MONITOR,
  REPORTS_AREAS.PAYMENT_PLANS,
];

// For customers dashboard settings we moved Historical Depot to new place in BCA-8141.
// That is why we have separate constant without this option
export const CUSTOMER_RELATED_REPORTS_AREAS_LIST = REPORTS_AREAS_LIST.filter(
  (option) => option.value !== REPORTS_AREAS.INCLUDE_HISTORICAL_PORTFOLIOS.value);